import { BrandPlanIntegrations, SelectedBlogPlatform, SelectedEmailPlatform } from 'types'
import { getTacticInfo, isBrandPlanIntegrationType } from 'components/TacticIntegrationList/utils'
import { ExternalIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export { getNormalizedTactics, normalizeTactic } from './normalizedTactics'

export const getProviderCounts = (
  externalIntegrations: ExternalIntegration[] | undefined,
  tactics: BrandPlanIntegrations[],
  selectedBlogPlatform: SelectedBlogPlatform | undefined,
  selectedEmailPlatform: SelectedEmailPlatform | undefined,
): {
  connectedProviders: ExternalIntegrationEnum[]
  totalPossibleProviders: ExternalIntegrationEnum[]
} => {
  // Get integration types for each tactic (filtering out nulls for SEO/Email without platforms)
  const integrationTypes = tactics
    .map((tactic) => getTacticInfo(tactic, selectedBlogPlatform, selectedEmailPlatform))
    .filter((info): info is NonNullable<typeof info> => info !== null)
    .map((info) => info.integrationType)

  if (!externalIntegrations) {
    return {
      connectedProviders: [],
      totalPossibleProviders: Array.from(new Set(integrationTypes)),
    }
  }

  const allConnectedProviderTypes = Array.from(new Set(externalIntegrations.map((integration) => integration.provider)))
  const providersWithTactics = allConnectedProviderTypes.filter((provider) => integrationTypes.includes(provider))
  const providersWithoutTactics = allConnectedProviderTypes.filter(
    (provider) => !integrationTypes.includes(provider) && isBrandPlanIntegrationType(provider),
  )
  const allPossibleProviders = [...integrationTypes, ...providersWithoutTactics]
  const totalPossibleProviders = Array.from(new Set(allPossibleProviders))
  const connectedProviders = Array.from(new Set([...providersWithTactics, ...providersWithoutTactics]))

  return {
    connectedProviders,
    totalPossibleProviders,
  }
}
